import { loopControlProps, makeControlProps, visibilityProps, typographyProps, backgroundProps } from './helper';

const properties = [
  makeControlProps('input', {
    pathValue: 'properties.backendname',
    label: 'Backendname'
  }),
  makeControlProps('input', {
    pathValue: 'properties.label',
    label: 'Label'
  }),
  makeControlProps('input', {
    pathValue: 'properties.value',
    label: 'Value'
  }),
  makeControlProps('select', {
    pathValue: 'properties.iscached',
    label: 'Cache value',
    options: [
      {label: 'Yes', value: true},
      {label: 'No', value: false},
    ]
  }),
  makeControlProps('input', {
    pathValue: 'properties.selected',
    label: 'Selected'
  }),
  makeControlProps('select', {
    pathValue: 'properties.labelPosition',
    label: 'Label position',
    options: [
      {label: 'right', value: 'right'},
      {label: 'left', value: 'left'},
    ],
  }),
  visibilityProps,
  loopControlProps
];

const view = [
  {
    selector: '.mbst-checkbox .q-item__label',
    controls: [
      Object.assign({}, typographyProps, {label: 'Label typography'})
    ]
  },
  {
    selector: '.mbst-checkbox .q-checkbox__bg, .mbst-checkbox .q-icon',
    controls: [
      makeControlProps('typography', {
        label: 'Control typography',
        color: {
          label: 'color',
          pathValue: 'color',
        },
      })
    ]
  },
  {
    selector: '.mbst-checkbox',
    controls: [
      makeControlProps('spacing', { label: 'Spacing' }),
      makeControlProps('borders', { label: 'Borders' }),
      backgroundProps,
    ]
  }

];

const actions = [true];

export default {
  properties,
  view,
  actions
}
